import styled from "@mui/material/styles/styled";
import { DatePicker, PickersDay } from "@mui/x-date-pickers";
import { Stack } from "../..";
const DatePickerStyled = styled(DatePicker)`
  width: 100%;
  .MuiInputBase-root {
    background-color: var(--mui-palette-elevation0-transparent);
    padding: 10px;
    border-radius: 8px;
  }
  .MuiInputBase-input {
    padding:0;
    box-sizing: border-box;
    height: 23px;
    font-size: 16px;
  }
  .MuiOutlinedInput-notchedOutline {
    border: 0;
  }

  ${(props) => `
    ${props.$isTextField && `
      .MuiInputAdornment-root .MuiIconButton-root:hover{
        background-color: initial;
      };
    `}
  `}

  ${(props) => `
    ${!props.$isTextField && `
      width: 40px;
      height: 40px;

      .MuiInputBase-root {
        background: none;
        margin: 0;
        padding: 0;
        height: 100%;
        width: 100%
      }

      .MuiInputAdornment-root {
        height: 100%;
        width: 100%;
        max-height: none;
        margin: 0;
      }

      .MuiInputBase-root {
        border: 0;
      }

      .MuiOutlinedInput-notchedOutline {
        display: none;
      }

      .MuiInputBase-input {
        display: none;
      }

      .MuiButtonBase-root {
        color:#EBEDF0;
        margin: 0;
        padding: 0;
        width: 40px;
        height: 40px;
        border-radius: 8px;
      }
    `}
  `}
`;
const DatePickerHeader = styled(Stack)`
  padding: 0 3rem 1rem;
  justify-content: center;
`;
const PickersDayWeekTypeStyled = styled(PickersDay)(({ theme, isSelected, isHovered, day }) => ({
  padding: "0!important",
  position: "relative",
  zIndex: "1",
  "&:hover, &:focus": {
    background: "none!important",
    outline: "none!important"
  },
  ...isSelected && {
    "&::before": {
      content: '""',
      zIndex: -2,
      backgroundColor: "var(--mui-palette-elevation3-main)",
      position: "absolute",
      top: "0",
      left: "0",
      right: "0",
      bottom: "0",
      ...day.day() === 1 && {
        borderTopLeftRadius: "50%",
        borderBottomLeftRadius: "50%"
      },
      ...day.day() === 0 && {
        borderTopRightRadius: "50%",
        borderBottomRightRadius: "50%"
      }
    },
    ...(day.day() === 0 || day.day() === 1) && {
      "&::after": {
        content: '""',
        zIndex: -1,
        backgroundColor: "var(--mui-palette-brand-main)",
        position: "absolute",
        top: "0",
        left: "0",
        right: "0",
        bottom: "0",
        borderRadius: "50%"
      }
    }
  },
  ...isHovered && {
    "&::before": {
      content: '""',
      backgroundColor: "var(--mui-palette-elevation3-main)",
      position: "absolute",
      zIndex: -2,
      top: "0",
      left: "0",
      right: "0",
      bottom: "0",
      ...day.day() === 1 && {
        borderTopLeftRadius: "50%",
        borderBottomLeftRadius: "50%"
      },
      ...day.day() === 0 && {
        borderTopRightRadius: "50%",
        borderBottomRightRadius: "50%"
      }
    },
    ...(day.day() === 0 || day.day() === 1) && {
      "&::after": {
        content: '""',
        zIndex: -1,
        backgroundColor: "var(--mui-palette-brand-main)",
        position: "absolute",
        top: "0",
        left: "0",
        right: "0",
        bottom: "0",
        borderRadius: "50%"
      }
    }
  }
}));
export {
  DatePickerHeader,
  DatePickerStyled,
  PickersDayWeekTypeStyled
};
